import { normalize } from 'normalizr';
import uniq from 'lodash/uniq';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

import { SCHEMA_ADD, SCHEMA_UPDATE, SCHEMA_ADD_BATCH } from './types';
import {
  placeSchema,
  themeSchema,
  lodgeSchema,
  sidetripSchema,
  placeListSchema,
  flightsSchema,
} from '../Schema';
import { getToken } from '../../lib/utils';
import { setLastPage } from '../actions/selectedPlaceActions';

export const fetchPlaceById = placeId => {
  return async (dispatch, getState, api) => {
    // const placeAlreadyExists = Boolean(getState().schema.places.byId[placeId]);
    // const activePlace = getState().schema.places.byId[placeId];
    // const placeAlreadyExists = Boolean(activePlace && activePlace.link);
    // if (!placeAlreadyExists) {
    const { data } = await api.getPlaceById(placeId, 'get');
    const images = await getPlaceCoverImages(placeId);

    let newState = {
      id: placeId,
      schema: 'places',
      data: {
        ...data,
        coverImages: images,
      },
    };

    dispatch(updatePlaceSchema(newState));
  };
};

async function getPlaceCoverImages(placeId) {
  try {
    const { data } = await api.get(endpoints.place.coverImages(placeId));
    return data.images;
  } catch (e) {
    console.log('Failed To get Place Cover images', e);
  }
}

export function storePlaceById(place) {
  const { entities, result } = normalize(place, placeSchema);
  return {
    type: SCHEMA_ADD,
    payload: {
      schema: 'places',
      data: entities.place[result],
    },
  };
}

export function storeDummyPlace(placeId) {
  return async dispatch => {
    dispatch(storePlace(placeId));
  };
}

export function storePlace(placeId) {
  return {
    type: SCHEMA_ADD,
    payload: {
      schema: 'places',
      data: { id: placeId },
    },
  };
}

export const getPlaceThemes = ({
  placeName,
  placeId,
  theme,
  limit,
  page,
  categories,
  searchTerm,
}) => {
  if (theme === 'sidetrips')
    return getSidetripsForPlace({ placeName, placeId, limit, page });
  if (theme === 'lodges') return getLodgesForPlace({ placeName, placeId, limit, page });
  if (theme === 'places') return getPlacesForPlace({ placeId, limit, page });
  if (theme === 'flights') return getFlightsForPlace({ placeId, placeName });
  // else its sightings or attractions then
  return async (dispatch, getState, api) => {
    const token = getToken();
    let queryObject = {
      placeName,
      placeId,
      theme,
      limit,
      page,
      searchTerm,
      // method: 'get',
      token,
    };

    const allCategories = categories === 'all';

    const response = searchTerm
      ? allCategories
        ? await api.getPlaceThemesBySearchAndCategory({ ...queryObject })
        : await api.getPlaceThemesBySearchAndCategory({
            ...queryObject,
            categories,
          })
      : allCategories
      ? await api.getPlaceThemes({ ...queryObject })
      : await api.getPlaceThemesByCategory({ ...queryObject, categories });

    const { entities, result } = normalize(response.data ? response.data : [], themeSchema);

    if (!response.headers['x-pagination-nextpage-num']) dispatch(setLastPage({ theme }));

    dispatch(storeThemesById(entities.themes, theme));
    if (categories && page === 1) {
      dispatch(refreshAndStorePlaceThemeIds(placeId, theme, result));
    } else if (searchTerm && page === 1) {
      dispatch(refreshAndStorePlaceThemeIds(placeId, theme, result));
    } else {
      dispatch(storePlaceThemeIds(placeId, theme, result));
    }
    return response.data;
  };
};

function storeThemesById(data, theme) {
  return {
    type: SCHEMA_ADD_BATCH,
    payload: {
      schema: theme,
      data,
    },
  };
}

export function storePlaceThemeIds(placeId, theme, data) {
  return (dispatch, getState) => {
    const place = getState().schema.places.byId[placeId];
    const oldThemes = getState().schema.places.byId[placeId][theme] || undefined;
    const newState = {
      schema: 'places',
      data: {
        ...place,
        [theme]: oldThemes ? uniq([...oldThemes, ...data]) : [...data],
      },
    };
    dispatch(updatePlaceSchema(newState));
  };
}

function refreshAndStorePlaceThemeIds(placeId, theme, data) {
  return (dispatch, getState, api) => {
    const place = getState().schema.places.byId[placeId];
    const newState = {
      schema: 'places',
      data: {
        ...place,
        [theme]: [...data],
      },
    };
    dispatch(updatePlaceSchema(newState));
  };
}

function updatePlaceSchema(payload) {
  return {
    type: SCHEMA_UPDATE,
    payload,
  };
}

// this store themes inside places -- is not in use
export const storePlaceThemes = (placeId, theme, data) => {
  return (dispatch, getState, api) => {
    const place = getState().schema.places.byId[placeId];
    const oldThemes = getState().schema.places.byId[placeId][theme] || undefined;
    const newState = {
      schema: 'places',
      data: {
        ...place,
        [theme]: oldThemes ? uniq([...oldThemes, ...data]) : [...data],
      },
    };
    dispatch(storeThemes(newState));
  };
};

const storeThemes = payload => {
  return {
    type: SCHEMA_UPDATE,
    payload,
  };
};
// -----------------------------------------------------

export const getLodgesForPlace = ({ placeName, placeId, limit, page }) => {
  return async (dispatch, getState, api) => {
    const token = getToken();
    const { data, headers } = await api.getLodgesForPlace({
      placeName,
      placeId,
      limit,
      page,
      // method: 'get',
      token,
    });
    if (!headers['x-pagination-nextpage-num']) dispatch(setLastPage({ theme: 'lodges' }));
    const { entities, result } = normalize(data ? data : [], lodgeSchema);
    dispatch(storeThemesById(entities.lodges, 'lodges'));
    dispatch(storePlaceThemeIds(placeId, 'lodges', result));
    return data;
  };
};

const getSidetripsForPlace = ({ placeName, placeId, limit, page }) => {
  return async (dispatch, getState, api) => {
    const { data, headers } = await api.getSidetripsForPlace({
      placeName,
      placeId,
      limit,
      page,
      // method: 'get',
    });
    if (!headers['x-pagination-nextpage-num'])
      dispatch(setLastPage({ theme: 'sidetrips' }));
    const { entities, result } = normalize(data ? data : [], sidetripSchema);
    dispatch(storeThemesById(entities.sidetrips, 'sidetrips'));
    dispatch(storePlaceThemeIds(placeId, 'sidetrips', result));
    return data;
  };
};

const getPlacesForPlace = ({ placeId, limit, page }) => {
  return async (dispatch, getState, api) => {
    const { data, headers } = await api.getPlacesForPlace({
      placeId,
      limit,
      page,
      // method: 'get',
    });
    if (!headers['x-pagination-nextpage-num']) dispatch(setLastPage({ theme: 'places' }));
    const { entities, result } = normalize(data, placeListSchema);
    dispatch(storeThemesById(entities.places, 'places'));
    dispatch(storePlaceThemeIds(placeId, 'places', result));
    return data;
  };
};

const getFlightsForPlace = ({ placeId, placeName }) => {
  return async (dispatch, getState, api) => {
    const newName = placeName.split('-');
    const { data, headers } = await api.getFlightsForPlace({
      from: newName[0].replace(' ', ''),
      to: newName[1].replace(' ', ''),
    });
    if (!headers['x-pagination-nextpage-num']) dispatch(setLastPage({ theme: 'flights' }));
    const { entities, result } = normalize(data ? data : [], flightsSchema);

    dispatch(storeThemesById(entities.flights, 'flights'));
    dispatch(storePlaceThemeIds(placeId, 'flights', result));
    return data;
  };
};

// ----------------------------------------------------
export const getThemeDetails = ({ link, theme }) => {
  return async (dispatch, getState, api) => {
    const { data } = await api.getThemeDetails({ link });
    dispatch(storeThemeDetails({ theme, data }));
  };
};

const storeThemeDetails = ({ theme, data }) => {
  return {
    type: SCHEMA_UPDATE,
    payload: {
      schema: theme,
      data,
    },
  };
};

// place jumbotron edits
export const savePlaceEdits = ({ id, img, data, onUploadProgress }) => async (
  dispatch,
  getState,
  api
) => {
  try {
    await api.savePlaceEdits({
      id,
      data,
    });
    dispatch(fetchPlaceById(id));
  } catch (e) {
    console.log('updating places failed', e);
    throw e;
  }
};

export const uploadPlaceImage = ({ id, img, url, onUploadProgress }) => async (
  dispatch,
  getState,
  api
) => {
  try {
    await api.uploadPlacesImage({
      id,
      img,
      url,
      onUploadProgress,
    });
  } catch (e) {
    throw new Error(`failed to upload: ${e.response.data.message}`);
  }
};



// WEBPACK FOOTER //
// ./src/redux/actions/placeActions.js